/**
 * @fileoverview Agent definition for personality-matcher-v2.
 *
 * This agent generates a synthetic personality profile from character attributes,
 * which is then used for deterministic matching against the inspiration database.
 *
 * @category entities.characters.analysis
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'personality-matcher-v2',
  kind: 'primitive',
  name: 'Personality Profile Generator',
  description: 'Generates a synthetic personality profile from character attributes for deterministic inspiration matching.',
  category: 'characters',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-02',
    taxonomyPath: 'entities.characters.analysis',
    usedBy: [
      'use-personality-matcher.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'character-snapshotter-single-v2',
    ],
  },
};
